export default {
  rice: "Rice",
  fruit: "Fruit",
  water: "Water",
  bread: "Bread",
  vegetable: "Vegetable",
  chicken: "Chicken",
  dairy: "Dairy",
  egg: "Egg",
  legume: "Legume",
  others: "Others",
  description: "Description",
};
